import {
  DescriptionWrapper,
  DescriptionTitle,
  EditorPreviewStyled,
} from './styled'

const ExpandableCardBody = ({ template }) => (
  <DescriptionWrapper>
    <DescriptionTitle>Описание</DescriptionTitle>
    <EditorPreviewStyled value={template} />
  </DescriptionWrapper>
)

export default ExpandableCardBody
